import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 3.312a6.75 6.75 0 1 0 6.75 6.75A6.757 6.757 0 0 0 9 3.312m0 12.375a5.625 5.625 0 1 1 5.625-5.625A5.63 5.63 0 0 1 9 15.687M4.336 3.147l-2.25 2.25a.563.563 0 1 1-.796-.795l2.25-2.25a.563.563 0 0 1 .796.796m12.375 2.25a.563.563 0 0 1-.796 0l-2.25-2.25a.563.563 0 0 1 .796-.795l2.25 2.25a.56.56 0 0 1 0 .796M12.938 9.5a.563.563 0 0 1 0 1.125H9a.56.56 0 0 1-.562-.563V6.125a.562.562 0 0 1 1.125 0V9.5z"
    }, null, -1)
  ])))
}
export default { render: render }